<style>
.time {
  font-size: 3.5rem;
  font-size: 15vh;
  font-weight: bold;
  color: var(--text-hero, rgba(0,0,0,0.48));
}

.small {
  font-size: 1.5rem;
}

.white {
  color: #fff;
}
</style>

<script>
export let total = 0;
export let elapsed = 0;
export let size = 'large';
export let color = 'black';
$: current = total - elapsed;

function pad(num, size) {
  return ('000' + num).slice(size * -1);
}

function secondsToTime(timeInSeconds) {
  const tis = isNaN(timeInSeconds) ? 0 : timeInSeconds;
  let time = parseFloat(tis).toFixed(3),
  hours = Math.floor(time / 60 / 60),
  minutes = Math.floor(time / 60) % 60,
  secs = Math.floor(time - minutes * 60),
  milliseconds = time.slice(-3);

  const output = `${pad(minutes, 2)}:${pad(secs, 2)}`;
  return hours > 0 ? `${pad(hours, 2)}:${output}` : output;
}
</script>

<div class="time" class:small="{size === 'small'}" class:white="{color === 'white'}">{secondsToTime(current)}</div>
